import { useState } from "react"

const usePpgSteps = () => {
    const [ppgSteps, setPpgSteps] = useState([
        {
            "title": "Daftar Ulang",
            "isShow": false,
            "detail": `<p>Daftar ulang dilakukan melalui platform EMIS atau SIAGA.
                        Dokumen yang diunggah dalam daftar ulang sebagai berikut:
                            <ol>
                                <li>Ijazah yang digunakan untuk linieritas mapel dan terligalisir</li>
                                <li>Pakta integritas sesuai template</li>
                                <li>Surat Ijin dari Pimpinan</li>
                                <li>Surat Keterangan sehat jasmani</li>
                            </ol>
                        </p>
                        <p>Adapun langkah-langkahnya sebagai berikut:
                            <ol>
                                <li>Login sistem menggunakan akun masing-masing</li>
                                <li>Pilih menu PPG Dalam Jabatan</li>
                                <li>Lengkapi data diri dan dokumen yang diminta</li>
                                <li>Memilih bidang studi PPG yang linear dengan ijazah S1/DIV</li>
                                <li>Pastikan data sudah benar, lalu klik "Kirim Pendaftaran"</li>
                            </ol>
                        </p>
                        <br />`
        },
        {
            "title": "Seleksi Administrasi",
            "isShow": false,
            "detail": `<p>Seleksi administrasi dilakukan oleh Kementerian Agama. Parameter seleksi meliputi linieritas dan kelengkapan dokumen. Seleksi administrasi atau verval ini dilakukan melalui EMIS atau SIAGA, dan hasilnya dapat diketahui melalui akun masing-masing guru.</p><br />`
        },
        {
            "title": "Lapor Diri ke LPTK",
            "isShow": false,
            "detail": `<p>Lapor Diri diwajibkan bagi guru yang dinyatakan lulus seleksi administrasi. Lapor Diri dilakukan mahasiswa ke LPTK melalui platform Lapor Diri masing-masing LPTK.</p>
                        <p>Dokumen yang diunggah dalam Lapor Diri sebagai berikut:
                            <ol>
                                <li>Ijazah yang digunakan untuk linieritas PPG beserta transkip nilai;</li>
                                <li>Kartu Tanda Penduduk (KTP);</li>
                                <li>Foto terbaru (latar warna merah; laki-laki menggunakan jas dan dasi warna hitam; perempuan menyesuaikan);</li>
                                <li>Dokumen RPL, terdiri dari:</li>
                                <p>
                                    <ul>
                                        <li>SK Mengajar sebagai guru maksimal 6 tahun terakhir;</li>
                                        <li>Dokumen Perangkat Pembelajaran yang pernah dibuat terdiri dari: RPP/Modul Ajar, Materi Ajar, LKPD, Alat Peraga/Media Pembelajaran, dan Instrumen Penilaian maksimal 12 semester;</li>
                                        <li>Dokumen Pengembangan Kompetensi Profesional yang pernah diikuti, terdiri dari sertifikat/piagam/Surat Keterangan mengikuti kegiatan ilmiah dari KKG/MGMP/Forum Sejenis maksimal 12 semester;</li>
                                        <li>Dokumen Pengelolaan Administrasi Pembelajaran dibuktikan dengan Surat Keterangan dari Kepala Sekolah/Madrasah tentang keaktifan guru di bidang manajerial;</li>
                                        <li>Dokumen Inovasi Pembelajaran dibuktikan dengan salah satu dari dokumen berikut: Modul Pembelajaran/Video Pembelajaran/Karya lainnya.</li>
                                    </ul>
                                </p>
                            </ol>
                        </p>
                        <br />`
        },
        {
            "title": "Orientasi Akademik",
            "isShow": false,
            "detail": `<p>Orientasi Akademik diberikan oleh LPTK kepada guru yang dinyatakan memenuhi seluruh berkas Lapor Diri. Orientasi Akademik dilaksanakan secara daring. Dalam orientasi akademik ini, mahasiswa akan memperoleh informasi dari LPTK terkait desain pembelajaran, sistem pendampingan, serta mekanisme penilaian.</p><br />`
        },
        {
            "title": "Mengikuti Pembelajaran",
            "isShow": false,
            "detail": `<p>Guru mengikuti pembelajaran PPG Daljab melalui platform pembelajaran digital yang disupervisi oleh LPTK. Berbeda dengan PPG model lama yang dilakukan secara syncronus, PPG Daljab ini dilakukan dengan memanfaatkan Learning Management System (LMS). Untuk Angkatan Ke-1, jumlah hari aktif pembelajaran selama 49 hari.</p><br />`
        },
        {
            "title": "Induksi dan Try Out",
            "isShow": false,
            "detail": `<p>Setelah mengikuti seluruh proses pembelajaran di LMS, peserta PPG Daljab akan memperoleh induksi pembahasan kisi-kisi UKMPPG melalui video yang dapat diakses dari mana saja dan kapan saja. Selain itu, peserta juga akan memperoleh kesempatan untuk mengikuti try out Uji Pengetahuan. Melalui kegiatan ini, peserta diharapkan dapat mengkaitkan antara substansi modul yang dipelajari dengan parameter ujian yang akan dilaksanakan melalui Uji Kinerja dan Uji Pengetahuan.</p><br />`
        },
        {
            "title": "Mengikuti Uji Kompetensi Mahasiswa PPG (UKMPPG)",
            "isShow": false,
            "detail": `<p>Setelah mengikuti seluruh rangkaian pembelajaran, para peserta harus melaksanakan Uji Kompetensi Mahasiswa PPG (UKMPPG) melalui platform <a target="_blank" href="https://ukm.ppg.kemdikbud.go.id">UKMPPG Kemendikbud</a> yang terdiri dari:
                            <ol>
                                <li>Uji Kinerja yang mengukur kemampuan peserta PPG dalam mengimplementasikan rencana pembelajaran secara memadai dalam bentuk video pembelajaran melalui platform</li>
                                <li>Uji Pengetahuan yaitu uji tulis berbasis komputer yang dilaksanakan untuk mengukur penguasaan pengetahuan untuk memenuhi capaian pembelajaran program PPG.</li>
                            </ol>
                        </p>`
        }
    ])
    return { ppgSteps, setPpgSteps }
}
export default usePpgSteps